module.exports = __webpack_public_path__ + "static/media/uwe_logo.349b854a.svg";